export const forum = '/forum/';

export const forumSubscribed = '/forum/subscribed/';
export const forumUpdated = '/forum/updated/';

export const forumLiked = '/forum/liked-by-me/';
export const forumCommented = '/forum/commented-by-me/';
export const forumReported = '/forum/reported/:topicSlug/';

export const forumTopics = '/forum/topics/';
export const forumTopicsCategory = '/forum/topics/:categorySlug/';

export const forumTopic = '/forum/category/:topicSlug/';  // kvoli seo zatial s 'category' namiesto 'topic'
export const forumTopicExplanation = '/forum/topic/explanation/:categorySlug/';
export const forumTopicNewInCategory = '/forum/topic/new/:categorySlug/';
export const forumTopicInfo = '/forum/topic/info/:topicSlug/';
export const forumTopicCoverUpload = '/forum/topic/cover/upload/:formName/:topicSlug/';
export const forumTopicEdit = '/forum/topic/edit/:topicId/';
export const forumTopicModeratorInvitation = '/forum/topic/moderator-invitation/:topicSlug/:username/';

export const forumPostNew = '/forum/thread/new/';
export const forumPostNewInCategory = '/forum/thread/new/:categorySlug/';
export const forumPostNewInTopic = '/forum/thread/new/:categorySlug/:topicSlug/';
export const forumPostNewInTopicOfType = '/forum/thread/new/:categorySlug/:topicSlug/:type/';
export const forumPostLikers = '/forum/:topicSlug/:postSlug/likers/';
export const forumPostCommentLikers = '/forum/:topicSlug/:postSlug/:commentId/likers/';
export const forumPostEdit = '/forum/post/edit/:postId/';
export const forumPostDetail = '/forum/:topicSlug([a-z-\\d]+)/:postSlug([a-z-\\d\\._]+)/';

export const forumContestNew = '/forum/contest/new/:topicSlug/';
export const forumContestEdit = '/forum/contest/edit/:contestId/';
export const forumTestingNew = '/forum/testing/new/:topicSlug/';
export const forumTestingEdit = '/forum/testing/edit/:postId/';
export const forumTestingCommentNew = '/forum/:topicSlug/:postSlug/comment/new/';
export const forumCounsellingNew = '/forum/counselling/new/:topicSlug/';
export const forumCounsellingReply = '/forum/counselling/reply/:questions/:topicSlug/';

export const forumCommentEdit = '/forum/comment/edit/:commentId/';

export const forumBrandDaysArchive = '/forum/archive/campaigns/';

export const forumSearch = '/forum/search/';
